import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import DeepfenceMappingForm from "./DeepfenceMappingForm";
import DeepfenceCredentialsForm from "./DeepfenceCredentialsForm";

export default function DeepfenceConfigListing(props) {
  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={DeepfenceMappingForm}
      CredentialsForm={DeepfenceCredentialsForm}
      componentName="Host"
      componentKey="hostName"
    />
  );
}
